import React from 'react';

/**
 * TooltipWrapper - Reusable tooltip component
 *
 * Displays a dark tooltip above the content on hover with a downward-pointing arrow.
 * Ensures consistent tooltip styling across the application.
 *
 * @param {Object} props
 * @param {React.ReactNode} props.children - Content to wrap with tooltip
 * @param {string} props.tooltip - Tooltip text to display on hover
 * @param {string} props.className - Additional CSS classes for the wrapper (optional)
 *
 * @example
 * <TooltipWrapper tooltip="This is helpful information">
 *   <button>Hover me</button>
 * </TooltipWrapper>
 */
export default function TooltipWrapper({ children, tooltip, className = '' }) {
  return (
    <div className={`group relative inline-block w-full ${className}`}>
      {/* Content with cursor-help to indicate hover information */}
      <div className="cursor-help">
        {children}
      </div>

      {/* Tooltip - shows on hover */}
      <div className="absolute bottom-full left-1/2 transform -translate-x-1/2 mb-2 px-3 py-2 bg-gray-900 text-white text-sm rounded-lg opacity-0 invisible group-hover:opacity-100 group-hover:visible transition-all duration-200 pointer-events-none z-50 whitespace-normal max-w-xs text-center">
        {tooltip}

        {/* Arrow pointing down */}
        <div className="absolute top-full left-1/2 transform -translate-x-1/2 -mt-1">
          <div className="border-4 border-transparent border-t-gray-900"></div>
        </div>
      </div>
    </div>
  );
}
